<template>
    <div>
        <!--nav bar-->
        <div class="col-12">
            <br/>
            <nav class="navbar navbar-expand-lg navbar-light">
                <div class="ml-auto">
                    <form class="form-inline my-2 my-lg-0">
                        <date-picker
                            v-model="search.date"
                            type="date"
                            :format="changeFormat"
                            :lang="lang"
                            range
                            placeholder="วันที่อัพเดต">
                        </date-picker>
                        &nbsp;
                        <multiselect
                            v-model="search.type"
                            class="form-control border-0"
                            :options="bag_type"
                            label="name"
                            placeholder="ประเภทถุง"
                            track-by="name">
                        </multiselect>
                        <multiselect
                            v-model="search.list"
                            class="form-control border-0"
                            :options="bagData_all"
                            :customLabel="materialLabel"
                            placeholder="รายการ"
                            track-by="id">
                        </multiselect>
                        <multiselect
                            v-model="search.vendor"
                            class="form-control border-0"
                            :options="vendor_all"
                            :customLabel="vendorLabel"
                            placeholder="บริษัท"
                            track-by="id">
                        </multiselect>
                        <button @click="searchBag"
                                class="btn btn-success my-2 my-sm-0"
                                type="button">
                            <icon name="search"></icon>
                            ค้นหา
                        </button>&nbsp;
                        <button @click="showImportModal"
                                class="btn add-list my-2 my-sm-0"
                                type="button">
                            <icon name="list-alt"></icon>
                            บันทึกการเช็คถุง
                        </button>
                        &nbsp
                        <button @click="exportExcel"
                                class="btn btn-secondary my-2 my-sm-0"
                                type="button">
                            <icon name="print"></icon>
                            รายงานบันทึกการเช็คถุง EXCEL
                        </button>
                        &nbsp
                    </form>
                </div>
            </nav>
        </div>
        <!--bar menu-->
        <div class="col-sm-12">
            <b-navbar toggleable="md" type="light" variant="light">
                <b-navbar-toggle target="search_nav_collapse"></b-navbar-toggle>
                <b-collapse is-nav id="search_nav_collapse">
                    <b-navbar-nav>
                        <b-nav-item
                            @click="clickBagData"
                            :class="{ active: seen === 1 }">
                            ข้อมูลเฉลี่ย ราคา/ใบ
                        </b-nav-item>
                        <b-nav-item
                            @click="clickCheckedBag"
                            :class="{ active: seen === 2 }">
                            บันทึกการเช็คถุง
                        </b-nav-item>
                    </b-navbar-nav>
                </b-collapse>
            </b-navbar>
        </div>
        <!--table save checked bag-->
        <div v-if="seen==2">
            <div class="col-12 table-responsive">
                <table class="table table-bordered">
                    <thead>
                    <tr>
                        <td scope="col">วันที่ส่ง</td>
                        <th scope="col">รายการ</th>
                        <th scope="col">บริษัท</th>
                        <th scope="col">จำนวนใบ/กิโลกรัม</th>
                        <th scope="col">จำนวนชั้น/ใบ</th>
                        <th scope="col">ความหนา(มิล)/ใบ</th>
                        <th scope="col">แก้ไข / ลบ</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="data in checkbag_list">
                        <td>{{ data.date | moment("DD/MM/YYYY") }}</td>
                        <td>{{ data.bag_name }}</td>
                        <td>{{ data.vendor_name }}</td>
                        <td>{{ data.quantity_per_kg }}</td>
                        <td>{{ data.pack_per_kg }}</td>
                        <td>{{ data.thickness_per_kg }}</td>
                        <td>
                            <a @click="showCheckBag(data.id)">
                                <icon name="pencil-alt"></icon>
                            </a>
                            &nbsp&nbsp
                            <a @click="showDeleteModal(data.id)">
                                <icon name="trash"></icon>
                            </a>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div v-if="checkbag_list.length > 0">
                <vue-pagination :pagination="dataPaginateCheckBag"
                                @paginate="getCheckBagPage">
                </vue-pagination>
            </div>
        </div>
        <!--table save bag-->
        <div v-if="seen==1">
            <div class="col-12 table-responsive">
                <table class="table table-bordered">
                    <thead>
                    <tr>
                        <td width="150px" scope="col">ลำดับ</td>
                        <th scope="col">รายการ</th>
                        <th width="150px" scope="col">ข้อมูล</th>
                    </tr>
                    </thead>
                    <tbody>
                    <template v-for="(data,index) in bagDataList">
                        <tr>
                            <td>{{ ++index }}</td>
                            <td>
                                {{ data.name }}
                            </td>
                            <td>
                                <template v-if="data.show==0">
                                    <button class="btn btn-primary"
                                            :disabled="data.groupBy_vendor.length < 1"
                                            v-on:click="() => { data.show = 1}">
                                        แสดง
                                    </button>
                                </template>
                                <template v-if="data.show==1">
                                    <button class="btn btn-primary"
                                            v-on:click="() => { data.show = 0 }">
                                        ซ่อน
                                    </button>
                                </template>
                            </td>
                        </tr>
                        <tr v-if="data.show==1">
                            <td></td>
                            <td>
                                <table class="text-center" align="center">
                                    <tr class="heading-table">
                                        <th scope="col">วันที่คำนวณล่าสุด</th>
                                        <th width="250px" scope="col">บริษัท</th>
                                        <th scope="col">เฉลี่ยจำนวนถุง(ใบ)/กิโลกรัม</th>
                                        <th scope="col">ค่าเฉลี่ย(บาท)/ใบ</th>
                                    </tr>
                                    <template v-for="info in data.groupBy_vendor">
                                        <tr style="background-color: white">
                                            <td>{{ info[0].date }}</td>
                                            <td>
                                                <template v-if="info[0].vendor">
                                                    {{ info[0].vendor.name }}
                                                </template>
                                                <template v-else>-</template>
                                            </td>
                                            <td>{{ info.mean }}</td>
                                            <td>{{ info.price_mean }}</td>
                                        </tr>
                                    </template>
                                </table>
                            </td>
                            <td></td>
                        </tr>
                    </template>
                    </tbody>
                </table>
            </div>
            <div v-if="bagDataList.length > 0">
                <vue-pagination :pagination="dataPaginateBagData"
                                @paginate="getBagDataPage">
                </vue-pagination>
            </div>
        </div>
        <!--modal import data-->
        <b-modal hide-footer ref="import_data" title="บันทึกการเช็คถุง">
            <div class="col-sm-12 text-center">
                <b-row>
                    <b-col sm="3" class="col-sm-5 text-right">
                        <label>รายการ</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6">
                        <template v-if="form.id">
                            <input class="form-control" v-model="form.bag_name" disabled/>
                        </template>
                        <template v-else>
                            <multiselect
                                v-model="form.list"
                                :options="bagData_all"
                                :customLabel="materialLabel"
                                :show-labels="false"
                                placeholder="รายการนับถุง"
                                track-by="id">
                            </multiselect>
                        </template>
                    </b-col>
                </b-row>
                <br/>
                <b-row>
                    <b-col sm="5" class="col-sm-5 text-right">
                        <label>บริษัท</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6">
                        <multiselect
                            v-model="form.vendor"
                            :options="optionVendor"
                            :customLabel="vendorLabel"
                            :show-labels="false"
                            placeholder="กรุณาเลือกบริษัท"
                            track-by="name">
                        </multiselect>
                        <br/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="5" class="col-sm-5 text-right">
                        <label>วันที่ส่งของ</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6">
                        <date-picker
                            v-model="form.date"
                            type="date"
                            :format="changeFormat"
                            :lang="lang"
                            placeholder="วันที่ส่งของ" confirm>
                        </date-picker>
                    </b-col>
                </b-row>
                <br/>
                <b-row>
                    <b-col sm="5" class="col-sm-5 text-right">
                        <label>จำนวนใบ / กิโลกรัม</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6">
                        <input type="number"
                               v-model="form.quantity_per_kg"
                               class="form-control"/>
                    </b-col>
                </b-row>
                <br/>
                <b-row>
                    <b-col sm="5" class="col-sm-5 text-right">
                        <label>จำนวนชั้น / ใบ</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6">
                        <input type="number"
                               v-model="form.pack_per_kg"
                               class="form-control"/>
                    </b-col>
                </b-row>
                <br/>
                <b-row>
                    <b-col sm="5" class="col-sm-5 text-right">
                        <label>ความหนา / ใบ</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6">
                        <input type="number"
                               v-model="form.thickness_per_kg"
                               class="form-control"/>
                    </b-col>
                </b-row>
            </div>
            <br/>
            <b-row>
                <div class="col text-center">
                    <button type="button"
                            @click="saveCheckBag"
                            class="btn btn-success">
                        <icon name="save" style="width: 25px"></icon>
                        บันทึก
                    </button>
                    &nbsp&nbsp
                    <button type="button"
                            @click="hideImportModal"
                            class="btn btn-outline-secondary">
                        <icon name="times" style="width: 25px"></icon>
                        ยกเลิก
                    </button>
                </div>
            </b-row>
        </b-modal>
        <b-modal hide-header hide-footer ref="delete_data">
            <div style="text-align: center;">
                <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                <br/>
                <button @click="deleteCheckBag"
                        type="button"
                        class="btn btn-success">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button @click="hideDeleteModal"
                        type="button"
                        class="btn btn-secondary">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <br/>
    </div>
</template>

<script>
import {mapState} from "vuex";
import VuePagination from "../../Pagination";
import Multiselect from "vue-multiselect";
import moment from "moment";
import DatePicker from 'vue2-datepicker'
import NavItem from "bootstrap-vue/es/components/nav/nav-item";
import {domain} from "../../../util/Constants";

export default {
    name: "check-bag",
    components: {
        NavItem,
        VuePagination, Multiselect, DatePicker
    },
    created() {
        //get checked bag SB
        //get bag data SB
        this.$store.dispatch("BagData/setBagData");
        this.$store.dispatch('BagData/getBagDataFromStatus');
        this.$store.dispatch("BagData/getBagType");
        this.$store.dispatch("BagData/getBagDataAll");

        this.$store.dispatch("CheckBag/setCheckedBag");
        this.$store.dispatch("CheckBag/clearData");
        this.$store.dispatch("Vendor/getVendorAll");

        this.getCurrentDate();
    },
    data() {
        return {
            dateFormat: 'DD/MM/YYYY',
            seen: 1,
            activeCloseDate: false,
            delete_id: "",
            bag_page: 1,
            check_page: 1,
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    computed: {
        ...mapState({
            checkbag_list: state => {
                return state.CheckBag.checkBagList
            },
            bagDataList: state => {
                return state.BagData.bagDataList
            },
            dataPaginateCheckBag: state => {
                return state.CheckBag.dataPaginate;
            },
            dataPaginateBagData: state => {
                return state.BagData.dataPaginate;
            },
            optionBagData: state => {
                return state.BagData.bag_status;
            },
            optionVendor: state => {
                return state.Vendor.vendorAll;
            },
            form: state => {
                return state.CheckBag.form;
            },
            replace_bag: state => {
                return state.CheckBag.checkBagData;
            },
            bag_type: state => {
                return state.BagData.bag_type
            },
            bagData_all: state => {
                return state.BagData.bag_all
            },
            vendor_all: state => {
                return state.Vendor.vendorAll;
            },
            search: state => {
                return state.BagData.search;
            }
        })
    },
    methods: {
        vendorLabel(option) {
            return `${option.vendor_id} - ${option.name}`
        },
        materialLabel(option) {
            return `${option.bag_code} - ${option.name}`
        },
        clickBagData() {
            if (this.seen == 2) {
                this.seen = 1;
                this.$store.dispatch("BagData/setBagData", this.bag_page).then(() => {
                    this.$store.dispatch("BagData/clearSearch");
                })
            }
        },
        clickCheckedBag() {
            if (this.seen == 1) {
                this.seen = 2;
                this.$store.dispatch("CheckBag/setCheckedBag", this.check_page).then(() => {
                    this.$store.dispatch("BagData/clearSearch");
                })
            }
        },
        showImportModal() {
            this.$refs.import_data.show();
        },
        hideImportModal() {
            this.$refs.import_data.hide();
            this.$store.dispatch("CheckBag/clearData");
        },
        showDeleteModal(id) {
            this.delete_id = id;
            this.$refs.delete_data.show();
        },
        hideDeleteModal() {
            this.$refs.delete_data.hide();
        },
        saveCheckBag() {
            if (!this.form.list) {
                alert("กรุณาเลือกรายการ")
            } else if (!this.form.vendor) {
                alert("กรุณาเลือกผู้จำหน่าย")
            } else if (this.form.quantity_per_kg < 0) {
                alert("กรุณาใส่จำนวนใบ/กิโลกรัม ให้ถูกต้อง")
            } else if (this.form.pack_per_kg < 0) {
                alert("กรุณาใส่จำนวนชั้น/ใบ ให้ถูกต้อง")
            } else if (this.form.thickness_per_kg < 0) {
                alert("กรุณาใส่ความหนา/ใบ ให้ถูกต้อง")
            } else {
                if (!this.form.date) {
                    this.form.date = moment().format("YYYY-MM-DD");
                }
                let data = {
                    date: moment(this.form.date).format("YYYY-MM-DD"),
                    material_id: "",
                    bag_id: "",
                    bag_type_id: "",
                    vendor_id: this.form.vendor.id,
                    quantity_per_kg: this.form.quantity_per_kg,
                    pack_per_kg: this.form.pack_per_kg,
                    thickness_per_kg: this.form.thickness_per_kg,
                };
                if (this.form.id) {
                    data.material_id = this.form.material_id;
                    data.bag_id = this.form.bag_id;
                    data.bag_type_id = this.form.bag_type_id;
                }
                if (this.form.list) {
                    //console.log(this.form.list);
                    data.material_id = this.form.list.material_id;
                    data.bag_id = this.form.list.id;
                    data.bag_type_id = this.form.list.bag_type;
                }
                //console.log(data);
                this.$store.dispatch('CheckBag/save', {
                    id: this.form.id,
                    data: data
                }).then(() => {
                    this.hideImportModal();
                    // this.$store.dispatch("CheckBag/setCheckedBag").then(()=>{
                    this.getCheckBagPage();
                    // this.getBagDataPage()
                    // });
                })
            }
        },
        showCheckBag(id) {
            this.showImportModal();
            this.$store.dispatch("CheckBag/show", id);
        },
        deleteCheckBag() {
            this.$store.dispatch("CheckBag/delete", this.delete_id)
                .then(() => {
                    this.hideDeleteModal();
                    this.$store.dispatch("CheckBag/getCheckBagFromType", {
                        page: 1,
                        type_id: 1
                    }).then(() => {
                        this.seen = 2
                        this.$store.dispatch("BagData/getBagDataFromType", {
                            page: 1,
                            type_id: 1
                        })
                    });
                })
        },
        getCurrentDate() {
            const currentDate = moment().format("YYYY-MM-DD");
            this.form.date = currentDate;
        },
        searchBag() {
            let data = {
                page: this.check_page,
                bag_id: "",
                vendor_id: "",
                date_start: this.search.date.length > 0 ? moment(this.search.date[0]).format("YYYY-MM-DD") : '',
                date_end: this.search.date.length > 0 ? moment(this.search.date[1]).format("YYYY-MM-DD") : '',
                type_id: "",
                seen: this.seen,
                excel: '',
            };
            if (this.search.list) {
                data.bag_id = this.search.list.id;
            }
            if (this.search.vendor) {
                data.vendor_id = this.search.vendor.id
            }
            if (this.search.type) {
                data.type_id = this.search.type.id;
            }
            if (this.seen == 1) {
                this.$store.dispatch("BagData/search", data) //search data
            }
            if (this.seen == 2) {
                this.$store.dispatch("CheckBag/search", data) //search check bag
            }
        },
        exportExcel() {
            if (this.seen == 2) {
                let data = {
                    bag_id: "",
                    vendor_id: "",
                    date_start: this.search.date.length > 0 ? moment(this.search.date[0]).format("YYYY-MM-DD") : '',
                    date_end: this.search.date.length > 0 ? moment(this.search.date[1]).format("YYYY-MM-DD") : '',
                    type_id: "",
                    seen: this.seen,
                    excel: 'excel',
                };
                if (this.search.list) {
                    data.bag_id = this.search.list.id;
                }
                if (this.search.vendor) {
                    data.vendor_id = this.search.vendor.id
                }
                if (this.search.type) {
                    data.type_id = this.search.type.id;
                }
                window.open(domain + "/bag_data_search?seen=" + data.seen + "&bag_id=" + data.bag_id + "&vendor_id=" + data.vendor_id + "&type_id=" + data.type_id + "&date_start=" + data.date_start + "&date_end=" + data.date_end + "&excel=" + data.excel)
            } else {
                alert('กรุณากดที่ บันทึกการเช็ตถุง ก่อน')
            }
        },
        getVendorFromVendor(bag) {
            this.form.vendor = "";
            if (bag) {
                let data = {
                    material_id: bag.material_id
                };
                this.$store.dispatch("CheckBag/getVendorFromVendor", data)
            } else {
                this.form.vendor = "";
            }
        },
        getCheckBagPage() {
            this.check_page = this.dataPaginateCheckBag.current_page;
            this.searchBag()
            // this.$store.dispatch("CheckBag/setCheckedBag",this.check_page)
        },
        getBagDataPage() {
            this.bag_page = this.dataPaginateBagData.current_page;

            this.$store.dispatch("BagData/setBagData", this.bag_page)
        },
    }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/button-checkBag.css";

.navbar-light .navbar-nav .show > .nav-link,
.navbar-light .navbar-nav .active > .nav-link,
.navbar-light .navbar-nav .nav-link.show,
.navbar-light .navbar-nav .nav-link.active {
    background-color: #F9C867;
    color: black;
    font-weight: 900;
}

.navbar-nav .nav-link {
    color: black;
    margin-left: 5px;
}

.heading-table {
    background-color: #CDC4C4;
}
</style>
